import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    descriptionWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    descriptionTicketNumber: {
        fontSize: "10px !important",
        fontWeight: 700,
        color: theme.palette.primary.dark,
    },
    description: {
        fontSize: "14px !important",
        fontWeight: 700,
        color: theme.palette.info.main,
    },
}));
